export const DISPUTE_STATE_REQUIRED_ACTION = 'REQUIRED_ACTION';
export const DISPUTE_STATE_REQUIRED_OTHER_PARTY_ACTION = 'REQUIRED_OTHER_PARTY_ACTION';
export const DISPUTE_STATE_UNDER_PAYPAL_REVIEW = 'UNDER_PAYPAL_REVIEW';
export const DISPUTE_STATE_RESOLVED = 'RESOLVED';
export const DISPUTE_STATE_OPEN_INQUIRIES = 'OPEN_INQUIRIES';
export const DISPUTE_STATE_APPEALABLE = 'APPEALABLE';
export const DISPUTE_AUTH_ERROR = 'SWAG_PAYPAL__NOT_AUTHORIZED';

export default {
    DISPUTE_STATE_REQUIRED_ACTION,
    DISPUTE_STATE_REQUIRED_OTHER_PARTY_ACTION,
    DISPUTE_STATE_UNDER_PAYPAL_REVIEW,
    DISPUTE_STATE_RESOLVED,
    DISPUTE_STATE_OPEN_INQUIRIES,
    DISPUTE_STATE_APPEALABLE,
    DISPUTE_AUTH_ERROR,
};
